// import { configureStore } from "@reduxjs/toolkit";

// import reducer from "./reducer";

// const store = configureStore({
//   reducer: {
//     reducer,
//   },
// });

// export default store;







import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import reducer from "./reducer";

// Persist config (only for the favorites part)
const persistConfig = {
  key: "favorites",
  storage: sessionStorage,
  whitelist: ["favProduct"] // Only persist the favProduct field
};

// Wrap your existing reducer
const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: {
    reducer: persistedReducer, // Maintain your existing structure
  },
});

export const persistor = persistStore(store);
export default store;